import React from 'react';

import { Select, SelectProps } from '@mantine/core';

export const athleteStatusOptions = {
  all: ['Prospect', 'Visitor', 'Trial', 'Non-Paying Member', 'Member', 'Alumni'],
  onStart: ['Member', 'Non-Paying Member', 'Trial', 'Visitor', 'No status change'],
  onEnd: ['Prospect', 'Visitor', 'Trial', 'Non-Paying Member', 'Member', 'Alumni', 'No status change'],
};

type AthleteStatusSelectProps = Omit<SelectProps, 'data'> & {
  type?: 'all' | 'onStart' | 'onEnd';
  excludeValue?: string;
};

const AthleteStatusSelect = ({
  type = 'all',
  excludeValue,
  ...selectProps
}: AthleteStatusSelectProps): JSX.Element => {
  let options = athleteStatusOptions[type];

  if (excludeValue && excludeValue !== 'No status change') {
    options = options.filter(option => option !== excludeValue);
  }
  return <Select data={options} {...selectProps} />;
};

export default AthleteStatusSelect;
